module.exports = __webpack_public_path__ + "static/114_001-2540512dc4efc70025ad648c9740e209.jpg";